import { useState, useEffect } from 'react';

// Hero images for the dashboard carousel
const HERO_IMAGES = [
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/0f803933e21123e9c30897551279330ebc0fc68a630c5a41370e927923905ee3.png",
    alt: "Teacher reading to diverse toddlers"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/28d2d788e22885bc294545b8d07347b8c88f46524d80a57100bca041e8b60cfa.png",
    alt: "Bright colorful daycare classroom"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/8c1c5e565a9c368d17df51a6148dbb5869e42b44d31cec9ac3cb6fb1c673f932.png",
    alt: "Parent dropping off child at daycare"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/c6f0d7a063a57e141660c57af8044d4d762366e23f557ec46cf83bfcddcdd048.png",
    alt: "Kids doing arts and crafts"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/93ebf8e510b9397214f7aa6fa5c92d0c0b1d8dcc15e0266652aaa086d4da25db.png",
    alt: "Children playing on outdoor playground"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/c9f725d23b0e1e829bc00a8240771ddd681926342611f1d290f8504ffcf4fb28.png",
    alt: "Toddlers enjoying snack time"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/d9e9f34a83c34b11673205e8fcd448b32f019970dbf72afe065b917f866ee027.png",
    alt: "Peaceful daycare nap room"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/0220b9ec10a1114a26d9365073064160698e645322560e1b829396e3a9d66703.png",
    alt: "Circle time activities with teacher"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/ac1ad305-2681-4919-9db2-8590598419fa/images/252b2bdf68b1fbdeb6a0480d967f5f1d0cfa467bdb1f553eb980dd960222d825.png",
    alt: "Seasonal craft activities"
  }
];

const HeroCarousel = ({ userName }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Get greeting based on time of day
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % HERO_IMAGES.length);
        setIsTransitioning(false);
      }, 500); // Half of transition duration
    }, 6000); // Change image every 6 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div 
      className="relative w-full h-48 sm:h-56 md:h-64 lg:h-72 overflow-hidden"
      data-testid="hero-carousel"
    >
      {/* Background Images with Fade */}
      {HERO_IMAGES.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentIndex ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={image.url}
            alt={image.alt}
            className="w-full h-full object-cover"
          />
        </div>
      ))}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#2F6DB5]/70 via-[#2F6DB5]/50 to-transparent" />
      
      {/* Bottom fade for smooth transition to content */}
      <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent" />

      {/* Welcome Text */}
      <div className="absolute inset-0 flex items-center">
        <div className="px-6 sm:px-10 md:px-16 max-w-2xl">
          <h2 
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 drop-shadow-lg"
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}
          >
            {getGreeting()}, {userName || 'there'}!
          </h2>
          <p 
            className="text-base sm:text-lg text-white/90 drop-shadow-md"
            style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.3)' }}
          >
            Welcome back to ToDays Kidz Simple Sign In
          </p>
        </div>
      </div>

      {/* Subtle indicator dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
        {HERO_IMAGES.map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentIndex 
                ? 'bg-white w-4' 
                : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
